<template>
  <div class="header-firm-container position-relative w-100 d-flex align-items-center justify-content-end me-1 me-md-3">
    <!-- 1. WIDGET ROȘU: FIRMA DE LUCRU (CONTABILITATE) -->
    <div
      v-if="showContabilSection"
      class="header-contabil-centered d-flex align-items-center"
      :class="{ 'centered-absolute': isBothActive, 'ms-auto me-auto': !isBothActive }"
    >
      <!-- Desktop View -->
      <div class="d-none d-md-flex align-items-center bg-light-danger border border-danger border-opacity-25 rounded px-3 py-2 shadow-xs">
        <div class="d-flex align-items-center me-3">
          <span class="badge badge-danger fw-bold fs-8 me-2 px-2 py-1 text-uppercase shadow-xs">
            <i class="fa-solid fa-briefcase text-white me-1 fs-8"></i> Lucrezi pe
          </span>
          <div v-if="workStore.hasFirma" class="d-flex flex-column text-start me-2" style="max-width: 250px;">
            <span class="text-dark fw-bold fs-7 text-truncate lh-sm" :title="workStore.firmaDenumire">
              {{ workStore.firmaDenumire }}
            </span>
            <span class="text-danger fw-bold fs-8 mt-1 lh-1">
              CUI: {{ workStore.firmaCui || '-' }}
            </span>
          </div>
          <div v-else class="me-2">
            <span class="text-danger fw-bold fs-7">Nicio firmă selectată</span>
          </div>
        </div>

        <button
          v-if="workStore.hasFirma"
          type="button"
          class="btn btn-sm btn-light-danger text-danger fw-bold py-1 px-2 d-flex align-items-center gap-1"
          @click="goToWorkSearch"
          title="Schimbă firma pe care lucrezi"
        >
          <i class="fa-solid fa-arrows-rotate fs-7"></i>
          <span class="fs-8">Schimbă</span>
        </button>

        <button
          v-else
          type="button"
          class="btn btn-sm btn-danger fw-bold py-1 px-3 fs-7"
          @click="goToWorkSearch"
          title="Selectează firma pentru lucru"
        >
          <i class="fa-solid fa-magnifying-glass me-1 fs-8"></i> Selectează
        </button>
      </div>

      <!-- Mobile Compact View -->
      <button
        type="button"
        class="d-flex d-md-none align-items-center btn btn-sm btn-light-danger text-danger border border-danger border-opacity-25 rounded-pill px-2 py-1 shadow-xs gap-1 mobile-firm-chip"
        @click="goToWorkSearch"
        title="Schimbă firma de lucru"
      >
        <i class="fa-solid fa-briefcase fs-8 text-danger"></i>
        <span class="fw-bold fs-8 text-truncate text-start" style="max-width: 90px;">
          {{ workStore.hasFirma ? workStore.firmaDenumire : 'Lucru firmă' }}
        </span>
        <i class="fa-solid fa-chevron-down fs-9 opacity-75"></i>
      </button>
    </div>

    <!-- 2. WIDGET VERDE: FIRMA MEA (CLIENT) -->
    <div v-if="showClientSection" class="header-client-right d-flex align-items-center ms-auto">
      <!-- Desktop View -->
      <div class="d-none d-md-flex align-items-center bg-light-success border border-success border-opacity-25 rounded px-3 py-2 shadow-xs">
        <div class="d-flex align-items-center me-3">
          <span class="badge badge-success fw-bold fs-8 me-2 px-2 py-1 text-uppercase shadow-xs">
            <i class="fa-solid fa-building text-white me-1 fs-8"></i> Firma Mea
          </span>
          <div v-if="clientFirma" class="d-flex flex-column text-end me-2" style="max-width: 250px;">
            <span class="text-dark fw-bold fs-7 lh-sm text-break" :title="clientFirma.denumire" style="display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
              {{ clientFirma.denumire }}
            </span>
            <span class="text-success fw-bold fs-8 mt-1 lh-1">
              CUI: {{ clientFirma.cui || '-' }}
            </span>
          </div>
          <div v-else class="me-2">
            <span class="text-success fw-bold fs-7">Fără firmă activă</span>
          </div>
        </div>

        <button
          v-if="hasMultipleFirme"
          type="button"
          id="btn-schimba-firma"
          class="btn btn-sm btn-light-success text-success fw-bold py-1 px-2 d-flex align-items-center gap-1"
          @click="openClientSelectModal"
          title="Schimbă Firma Mea"
        >
          <i class="fa-solid fa-arrows-rotate fs-7"></i>
          <span class="fs-8">Schimbă</span>
        </button>
      </div>

      <!-- Mobile Compact View -->
      <div
        class="d-flex d-md-none align-items-center bg-light-success text-success border border-success border-opacity-25 rounded-3 px-2 py-1 shadow-xs gap-1 mobile-firm-box"
        :class="{ 'cursor-pointer': hasMultipleFirme }"
        @click="hasMultipleFirme ? openClientSelectModal() : null"
        :title="hasMultipleFirme ? 'Apasă pentru a schimba firma' : ''"
      >
        <i class="fa-solid fa-building fs-8 text-success me-1 flex-shrink-0"></i>
        <div class="d-flex flex-column text-start" style="max-width: 140px;">
          <span class="fw-bold fs-8 text-dark lh-sm text-break" style="display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
            {{ clientFirma ? clientFirma.denumire : 'Alege firma' }}
          </span>
          <span class="text-success fw-semibold fs-9 lh-1 mt-1" v-if="clientFirma && clientFirma.cui">
            CUI: {{ clientFirma.cui }}
          </span>
        </div>
        <i v-if="hasMultipleFirme" class="fa-solid fa-chevron-down fs-9 opacity-75 ms-1 flex-shrink-0"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '../../stores/user';
import { useWorkFirmStore } from '../../stores/workFirmStore';

export default {
  name: 'AppHeaderFirmWidget',
  setup() {
    const userStore = useUserStore();
    const workStore = useWorkFirmStore();
    return { userStore, workStore };
  },
  computed: {
    canWork() {
      if (this.$gate && typeof this.$gate.canWorkOnFirms === 'function') {
        return this.$gate.canWorkOnFirms();
      }
      return this.$gate?.isAdmin() || false;
    },
    clientFirma() {
      const u = this.userStore.user;
      if (u?.firma_curenta && typeof u.firma_curenta === 'object') {
        return u.firma_curenta;
      }
      if (this.userStore.firmaCurenta && typeof this.userStore.firmaCurenta === 'object') {
        return this.userStore.firmaCurenta;
      }
      if (window.initialUserData?.firma_curenta && typeof window.initialUserData.firma_curenta === 'object') {
        return window.initialUserData.firma_curenta;
      }
      return null;
    },
    showClientSection() {
      if (!this.canWork) return true;
      const mode = this.userStore.currentSidebarMode || 'tot';
      return mode === 'client' || mode === 'tot';
    },
    showContabilSection() {
      if (!this.canWork) return false;
      const mode = this.userStore.currentSidebarMode || 'tot';
      return mode === 'contabil' || mode === 'tot';
    },
    isBothActive() {
      return this.showContabilSection && this.showClientSection;
    },
    hasMultipleFirme() {
      if (typeof window.initialUserData?.has_multiple_firme === 'boolean') {
        return window.initialUserData.has_multiple_firme;
      }
      return true; // fallback
    }
  },
  methods: {
    openClientSelectModal() {
      window.dispatchEvent(new Event('open-modal-schimba-firme'));
    },
    goToWorkSearch() {
      this.workStore.clearFirma();
      if (this.$route?.path !== '/administrare/work') {
        this.$router.push('/administrare/work').catch(() => {});
      }
    }
  }
};
</script>

<style scoped>
.header-firm-container {
  min-height: 48px;
}
.centered-absolute {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
.shadow-xs {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.fs-7 {
  font-size: 0.95rem !important;
}
.fs-8 {
  font-size: 0.82rem !important;
}
.fs-9 {
  font-size: 0.72rem !important;
}

@media (max-width: 991px) {
  .header-firm-container {
    min-height: auto;
  }
  .centered-absolute {
    position: static;
    transform: none;
    margin-right: 0.5rem;
  }
  .mobile-firm-chip {
    white-space: nowrap;
    line-height: 1.2;
    transition: all 0.2s ease;
  }
  .mobile-firm-chip:active {
    transform: scale(0.96);
  }
}
</style>
